import React from 'react'
import flowRight from 'lodash/flowRight'
import SelectionControlGroup from 'shared/components/SelectionGroupControl'
import withDialog, { WrappedProps } from 'shared/hocs/withDialog'
import { ConfirmationType } from 'shared/components/Notes/models/confirmation'
import TextField, { FieldLabel } from 'shared/components/TextField'
import styled from 'styled-components'
import CustomTooltip from 'shared/components/CustomTooltip'
import { FLAG_WARNING_COLOR, FLAG_DANGER_COLOR } from 'shared/constants/participant'
import Box from 'shared/components/Box'

type Props = WrappedProps<ConfirmationType> & {
  label?: string
  description?: string
  isFlag?: boolean
}

function FlagActionConfirmationDialog(props: Props) {
  const { formState, formHandlers, label = 'Message', description = '', isFlag = false } = props
  const { fields, errors } = formState
  const { onElementChange, onChange } = formHandlers

  return (
    <FlagActionConfirmationDialogBodyContainer className="confirm-dialog-container">
      <Title mb="20px">
        Flag This Member{' '}
        <CustomTooltip
          placement="bottom"
          className="tooltip_flag"
          width="25"
          height="24"
          toopTipMaxWidth="380px"
          title="These selections will be present on Check-In/Out and Attendance List. Selections will be always shown until manually removed."
        />
      </Title>
      <Box mb="10px">
        <FieldLabel mb="10px !important">Status</FieldLabel>
        <Box>
          <SelectionControlGroup
            id="type"
            name="type"
            className="flag-type-selection"
            controls={[
              {
                label: 'Reminder (Member can still check-in)',
                value: 'warn',
              },
              {
                label: 'Stop Member at Check-In',
                value: 'stop',
              },
            ]}
            value={fields.type}
            onChange={val => {
              onElementChange(val, 'type')
            }}
            type="radio"
          />
        </Box>
      </Box>
      <Box>
        <FieldLabel mb="10px !important">Note*</FieldLabel>
        <TextField
          id="message"
          placeholder="Write your reason here"
          maxRows={3}
          rows={3}
          value={fields.message}
          onChange={onElementChange}
          error={Boolean(errors.message)}
          errorText={errors.message}
          disabled={false}
        />
      </Box>
    </FlagActionConfirmationDialogBodyContainer>
  )
}

const WrappedFlagActionConfirmationDialog = flowRight(withDialog())(FlagActionConfirmationDialog)

const Title = styled(Box)`
  line-height: 24px;
  font-size: 20px;
  font-weight: 700;
  display: flex;

  .tooltip_flag {
    margin-left: 5px;
  }
`

const FlagActionConfirmationDialogBodyContainer = styled(Box)`
  color: ${({ theme }) => theme.colors.secondary};
  padding: 40px 40px 0;
  width: 100%;
  max-width: 540px;

  .styled-tooltip {
    max-width: 550px;
  }

  .description {
    width: 100%;
    margin-bottom: 40px;
    text-align: center;

    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }

  .flag-type-selection {
    flex-direction: column;
    .md-selection-control-container {
      margin-bottom: 10px;
      padding: 15px 20px;
      background-color: ${({ theme }) => `${theme.colors.border}25`};
      border-radius: 5px;
      border: ${({ theme }) => `1px solid ${theme.colors.border}`};
      height: 44px;
      width: 100%;
      display: flex;

      &:nth-child(odd) {
        border-left: 10px solid ${FLAG_WARNING_COLOR};
      }
      &:nth-child(even) {
        border-left: 10px solid ${FLAG_DANGER_COLOR};
      }
    }
  }
`

WrappedFlagActionConfirmationDialog.defaultProps = {
  dialogClassName: 'dialog--large',
  continueIsDisabled(data: ConfirmationType) {
    return !data?.message?.length
  },
}

export default WrappedFlagActionConfirmationDialog
